import React, {useEffect} from "react";
import {BalloonEventModel} from "ts-core";
import {useParams} from "react-router-dom";
import EventDetailPage from "../pages/EventDetailPage.tsx";
import {useBalloonEventsData} from "../contexts/EventData.tsx";

export interface BalloonEventsUIProps {
    selectedEvent: BalloonEventModel | null;
}
export const BalloonDetails: React.FC<BalloonEventsUIProps> = ({selectedEvent}) => {
    const params = useParams();
    const {openedEvent} = useBalloonEventsData()
    if(!openedEvent?.slug || (openedEvent.slug !== selectedEvent?.slug && openedEvent.slug !== selectedEvent?.id)) return null;
    return <EventDetailPage/>
}